import JokerProHeader from "../../components/header/JokerVideoHeader";
import { useTranslation } from "react-i18next";
import AssetsPack from "../../util/AssetsPack";
import Footer from "../../components/footer/Footer";
import MainTemplate from "../Templates/MainTemplate";
import style from "./JokerDownload.module.css";
import OverDivComponent from "../Main/components/OverDivComponent";
import { sectionMainPageList } from "../../util/CollectionData";
import Section from "../Main/Section";
import { ApkLink } from "../../util/Constant";

const JokerDownload = () => {
  const { t } = useTranslation();

  const header = (
    <JokerProHeader
      headerText={t("nav_bar.download")}
      title={t("joker_download_page.title_1")}
      highlightLabel={t("joker_download_page.title_2")}
      description={t("joker_download_page.sub_title")}
      bgImage={AssetsPack.image.BG_JOKER_DOWNLOAD_HEADER}
      image={AssetsPack.image.JOKER_DOWNLOAD_HEADER}
      isDownloadTagNotVisible
    >
      <></>
    </JokerProHeader>
  );

  const body = (
    <div className={style["body-container"]}>
      {sectionMainPageList.map((item, index) => (
        <div
          key={index}
          className={style["relative-container"]}
          style={{
            backgroundImage: `url(${item.backgroundImg})`,
          }}
        >
          <Section overlays={item.overlayList} />
          <div className={style["joker-info-container"]}>
            <OverDivComponent
              title={item.title}
              description={item.description}
              downloadLink={ApkLink}
              learnMoreLink={"/downloadApk"}
              secondButtonName={t("global_component.installation_guide")}
            />
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <MainTemplate
      body={body}
      footer={<Footer />}
      header={header}
      fullWidthHeaderIpad
    />
  );
};

export default JokerDownload;
